import { useReportLoadError } from "../../../utils/useReportLoadError";
import {
	RetryableLoadError,
	type RetryableLoadErrorProps,
} from "../../patterns/retryable-load-error";

export interface ReportedRetryableLoadErrorProps extends RetryableLoadErrorProps {
	error: Error;
}

export const ReportedRetryableLoadError = ({
	error,
	...retryableLoadErrorProps
}: ReportedRetryableLoadErrorProps) => {
	useReportLoadError(error);

	return <RetryableLoadError {...retryableLoadErrorProps} />;
};
